import { render, staticRenderFns } from "./PerfectMindSidebar.vue?vue&type=template&id=0c8f5e20"
import script from "./PerfectMindSidebar.vue?vue&type=script&lang=js"
export * from "./PerfectMindSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports